import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20rain%20of%20encrypted%20data%20streams%20falling%20through%20dark%20space%2C%20deep%20cyberpunk%20noir%20aesthetic%2C%20red%20accent%20glowing%20nodes%2C%20mysterious%20dark%20web%20concept%2C%20cinematic%20atmosphere%2C%20high%20contrast%2C%20clean%20dark%20abstract%20background%2C%20depth%20and%20mystery&width=1920&height=800&seq=cta-bg-911&orientation=landscape"
          alt="下载911爆料网APP"
          title="911爆料网App下载入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-950/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-6xl font-black text-background-50 leading-[1.05] tracking-tight">
              第一时间
              <br />
              获取猛料
            </h2>
          </div>

          <div className="flex flex-col gap-6">
            <p className="text-base md:text-lg text-background-50/70 leading-relaxed max-w-md lg:ml-auto">
              下载911爆料网App，随时随地吃瓜不迷路。
              <br />
              商务合作、品牌声誉管理、爆料投递，欢迎联系我们。
            </p>
            <div className="lg:ml-auto">
              <Link
                to="/about"
                className="inline-flex items-center gap-3 px-7 py-3.5 text-sm font-semibold bg-background-50 text-foreground-900 rounded-full hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap"
              >
                立即下载
                <span className="w-8 h-8 flex items-center justify-center bg-foreground-900 text-background-50 rounded-full">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}